import { Component, OnInit } from '@angular/core';
import { ModalWindowComponent } from "../modal-window/modal-window.component";
import { ServerService } from "../../shared/services/server.service";
import { Router } from "@angular/router";

export interface Passwords {
  OldPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
}

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  passwords: Passwords = { OldPassword: '', NewPassword: '', ConfirmPassword: '' };
  errorMessage: string = '';
  successMessage: string = '';
  onChangeModel: boolean = false;
  updateLoading: boolean = false;
  constructor(private modalWindow: ModalWindowComponent,
    private serverService: ServerService,
    private router: Router) { }

  ngOnInit() {

  }

  savePasswords() {
    this.updateLoading = true;
    this.serverService.changePassword(this.passwords).then(res => {
      this.updateLoading = false;
      //return this.router.navigate(['/main', 'object', res, 'information']);
      this.errorMessage = '';
      this.successMessage = "Ваш текущий пароль успешно изменен";
      setTimeout(() => this.modalWindow.closeModalWindow(), 2000);
    }, (err: any) => {
      if (err.status == 400) {
        this.successMessage = '';
        let model_errors = err.error.modelState;
        for (let key in model_errors) {
          let value = model_errors[key];
          this.errorMessage = value[0];
        }
        this.updateLoading = false;
      }
    });
  }

  closeModalWindow() {
    this.modalWindow.closeModalWindow();
  }

  onchangeModel() {
    if (this.passwords.OldPassword !== '' && this.passwords.NewPassword !== '' && this.passwords.ConfirmPassword !== '')
      this.onChangeModel = true;
    else
      this.onChangeModel = false;
  }
}
